const Footer = () => {
  return (
    <footer className="mt-12">
      <p className="text-center text-gray-900">
        Made with ❤️ by{" "}
        <a className="font-semibold" href="https://clemensheithecker.com/">
          Clemens&nbsp;Heithecker
        </a>
        .
      </p>
      <p className="mt-1 text-center text-gray-900">
        Checkout the{" "}
        <a
          className="font-semibold"
          href="https://github.com/clemensheithecker/tower-of-hanoi"
        >
          project's repository on GitHub
        </a>
        .
      </p>
    </footer>
  );
};

export default Footer;
